import React from 'react';
import classNames from 'classnames';

import { colors } from 'settings/theme';

export default function Modal(props) {
    const {
        title,
        children,
        open,
        buttons,
        onClose
    } = props;

    if (!open) {
        return null;
    }

    return (
        <div>
            <div
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%,-50%)',
                    zIndex: 10001,

                    height: '100vh',
                    width: '100vw',

                    backgroundColor: colors.disabled,
                    opacity: 0.5,
                }}
                onClick={event => event.stopPropagation()}
            />
            <div
                className={classNames(
                    'dialog-container',
                    'dialog-skin-basic',
                    {'dialog-visible': open},
                )}
                id="dialog0Container"
                style={{
                    position: 'fixed',
                    zIndex: 10002,
                    width: '90vw',
                    maxWidth: 600,
                    maxHeight: '60vh',
                    opacity: 1,
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%,-50%)',
                    overflow: 'hidden', // todo: support scrollable modals? Probably a bad experience
                }}
            >
                <div className="dialog-header">
                    <button
                        style={{
                            border: 'none',
                            paddingTop: 2,
                        }}
                        className="dialog-close-button"
                    >
                        <span
                            className="dialog-close-button-icon"
                            onClick={onClose}
                        >
                        </span>
                    </button>
                    <h2 className="dialog-header-text">{title}</h2>
                </div>
                <div className="dialog-content-container">
                    <div className="dialog-content">
                        {children}
                        <div className="dialog-button-group">
                            {buttons}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/Modal.js